<template>
  <div class="skeleton">
    <div class="skeleton-header">
      <span class="skeleton-avatar"></span>
    </div>
    <div class="skeleton-content">
      <h3 class="skeleton-title"></h3>
      <ul class="skeleton-paragraph" v-if="column">
        <li v-for="(item, index) in list" :key="index"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  props: {
    // 字行数
    column: {
      type: Number,
      default: 0
    }
  },
  computed: {
    list() {
      return new Array(this.column).fill(0)
    }
  }
}
</script>

<style scoped>
.skeleton {
  display: table;
  width: 100%;
  box-sizing: border-box;
  padding: 1.6rem;
}
.skeleton-header {
  display: table-cell;
  padding-right: 1.6rem;
  vertical-align: top;
}
.skeleton-avatar {
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  background: #f2f2f2;
}
.skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}
.skeleton-title {
  width: 50%;
  height: 1.6rem;
  margin-top: 1.6rem;
  background: #f2f2f2;
}
ul,
li {
  list-style: none;
}
ul {
  margin-top: 1.8rem;
}
li {
  width: 100%;
  height: 1.6rem;
  background: #f2f2f2;
  margin-top: 1rem;
}
.skeleton-avatar,
.skeleton-paragraph li,
.skeleton-title {
  background: linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 37%,#f2f2f2 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/skeleton.vue